import { User } from '../../../types/user';
import { PLACEHOLDERS } from '../constants';

interface PersonalInfoCardProps {
  user: User;
}

/**
 * PersonalInfoCard - Card de dados pessoais
 *
 * Exibe e permite edição de dados pessoais do usuário
 * Migrado para Tailwind CSS v4
 */
export const PersonalInfoCard = ({ user }: PersonalInfoCardProps) => {
  // TODO: Implement edit functionality
  const isEditable = false;

  return (
    <div className="bg-[#2a2a2a] rounded-xl p-6 border border-[#333333] hover:border-[#F4CC04] transition-all duration-400">
      {/* Header */}
      <div className="flex items-center gap-3 mb-6">
        <div className="w-10 h-10 rounded-lg bg-[#F4CC04]/10 flex items-center justify-center flex-shrink-0">
          <svg className="w-5 h-5 text-[#F4CC04]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
          </svg>
        </div>
        <div className="text-2xl font-bold text-white m-0">Dados Pessoais</div>
      </div>

      {/* Form Fields */}
      <div className="space-y-4">
        {/* Name and Phone Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {/* Name */}
          <div className="flex flex-col gap-2">
            <label className="text-xs font-semibold text-[#999999] uppercase tracking-wide">
              Nome Completo
            </label>
            <input
              type="text"
              value={user.name}
              disabled={!isEditable}
              className="w-full px-4 py-3 bg-[#1a1a1a] border border-[#333333] rounded-lg
                text-white font-medium text-sm
                focus:outline-none focus:border-[#F4CC04] focus:ring-1 focus:ring-[#F4CC04]
                disabled:opacity-100 disabled:cursor-not-allowed
                transition-all duration-300"
            />
          </div>

          {/* Phone */}
          <div className="flex flex-col gap-2">
            <label className="text-xs font-semibold text-[#999999] uppercase tracking-wide">
              Telefone
            </label>
            <input
              type="tel"
              value={user.phone || ''}
              disabled={!isEditable}
              className="w-full px-4 py-3 bg-[#1a1a1a] border border-[#333333] rounded-lg
                text-white font-medium text-sm
                focus:outline-none focus:border-[#F4CC04] focus:ring-1 focus:ring-[#F4CC04]
                disabled:opacity-100 disabled:cursor-not-allowed
                transition-all duration-300"
            />
          </div>
        </div>

        {/* Email */}
        <div className="flex flex-col gap-2">
          <label className="text-xs font-semibold text-[#999999] uppercase tracking-wide">
            Email
          </label>
          <input
            type="email"
            value={user.email}
            disabled={!isEditable}
            className="w-full px-4 py-3 bg-[#1a1a1a] border border-[#333333] rounded-lg
              text-white font-medium text-sm
              focus:outline-none focus:border-[#F4CC04] focus:ring-1 focus:ring-[#F4CC04]
              disabled:opacity-100 disabled:cursor-not-allowed
              transition-all duration-300"
          />
        </div>

        {/* Personal Preferences */}
        <div className="flex flex-col gap-2">
          <label className="text-xs font-semibold text-[#999999] uppercase tracking-wide">
            Preferências Pessoais
          </label>
          <textarea
            placeholder={PLACEHOLDERS.personalPreferences}
            disabled={!isEditable}
            rows={4}
            className="w-full px-4 py-3 bg-[#1a1a1a] border border-[#333333] rounded-lg
              text-white font-medium text-sm resize-none
              placeholder:text-[#666666] placeholder:text-sm
              focus:outline-none focus:border-[#F4CC04] focus:ring-1 focus:ring-[#F4CC04]
              disabled:opacity-100 disabled:cursor-not-allowed
              transition-all duration-300"
          />
        </div>
      </div>
    </div>
  );
};
